window.isMobile = (function () {
  let flag =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
  return flag;
})();

// 引入资源
(function loadAssets() {
  function addElement(source, cb) {
    let sourceName =
      source && source.split("?")[0].slice(source.lastIndexOf("/") + 1);
    let sourceType = sourceName.split(".").pop();
    if (sourceType === "js") {
      let script = document.createElement("script");
      script.async = true;
      script.src = source;
      script.onload = () => {
        console.log("loaded");
        cb && cb();
      };
      document.body.appendChild(script);
    }
    if (sourceType === "css") {
      let link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = source;
      link.media = "print";
      link.onload = function () {
        console.log("loaded");
        this.media = "all";
        cb && cb();
      };
      document.head.appendChild(link);
    }
  }

  window.loadedScripts = [];

  window.loadScript = function (src, cb) {
    let scriptName = src && src.split("?")[0].slice(src.lastIndexOf("/") + 1);
    if (!scriptName || loadedScripts.indexOf(scriptName) >= 0) {
      cb && cb();
      return;
    }
    addElement(src, () => {
      loadedScripts.push(scriptName);
      cb && cb();
    });
  };

  window.loadScripts = function (arr, cb) {
    let count = 0;
    arr.forEach((src) => {
      let scriptName = src && src.split("?")[0].slice(src.lastIndexOf("/") + 1);
      let scriptType = scriptName.split(".").pop();
      if (loadedScripts.indexOf(scriptName) >= 0) {
        count++;
        return;
      }
      if (!scriptName || loadedScripts.indexOf(scriptName) >= 0) {
        return;
      }
      addElement(src, () => {
        count++;
        loadedScripts.push(scriptName);
        if (count === arr.length) {
          cb && cb();
        }
      });
    });
  };
})();

// YG Search Drawer Functionality
document.addEventListener('DOMContentLoaded', function() {
  const searchDrawer = document.querySelector('.search-drawer');
  if (!searchDrawer) return;
  const searchInput = searchDrawer.querySelector('input[type="search"][name="q"]');
  const ygQuickSearch = searchDrawer.querySelector('.yg-quick-search');
  if (!searchInput  || !ygQuickSearch) return;
  searchInput.addEventListener('input', function() {
    if(searchInput.value.length > 0) {
      ygQuickSearch.classList.add('yg-quick-search--hidden');
      console.log(111);
      
    } else {
      ygQuickSearch.classList.remove('yg-quick-search--hidden');
    }
  });
});